/**
 * Partners (Knack, VRT) start their headlines with "Factcheck:", which the scraper keeps. On the
 * site every card already is a factcheck, so the title drops it and starts with a capital:
 * "Factcheck: nee, de EU …" becomes "Nee, de EU …". The claim review keeps the partner's title.
 */
export const withoutFactcheckPrefix = (title: string): string => {
  const stripped = title.replace(/^\s*fact-?check\s*[:\-–—|]\s*/i, '').trim();
  if (!stripped) return title;
  return stripped.charAt(0).toLocaleUpperCase('nl-BE') + stripped.slice(1);
}
